<template>
  <v-skeleton-loader :loading="loading" transition="scale-transition" type="card">
    <v-card>
      <v-row class="my-0">
      <v-col>
      <v-card-title v-if="percentDif > 0 && chartValues.length > 0">
          ER Visits Per 1000
        <v-icon class="mdi mdi-arrow-down success--text ml-1" size="15"></v-icon>
        <span class="success--text">{{ percentDif }}%</span>
      </v-card-title>
      <v-card-title v-if="percentDif < 0 && chartValues.length > 0">
          ER Visits Per 1000
        <v-icon class="mdi mdi-arrow-up error--text ml-1" size="15"></v-icon>
        <span class="error--text">{{ Math.abs(percentDif) }}%</span>
      </v-card-title>
      <v-card-title v-if="percentDif === 0 && chartValues.length > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              ER Visits Per 1000
              <v-icon class="mdi mdi-swap-vertical ml-1" size="15"></v-icon> -
            </span>
          </template>
          <span>Less than 1% change</span>
        </v-tooltip>
      </v-card-title>
      <v-card-title v-if="chartValues.length < 1">
        ER Visits Per 1000
        <v-alert type="info">No Data for selected input</v-alert>
      </v-card-title>
        </v-col>
        <v-col v-if="view === 'dashboard top'" class="pt-0 text-right" cols="12" lg="6">
        <v-btn-toggle v-model="dashboardRange" class="pa-2" color="secondary" group exclusive>
          <v-btn small class="pa-4">
            3 Months
          </v-btn>

          <v-btn small class="pa-4">
            6 Months
          </v-btn>

          <v-btn small class="pa-4">
            12 Months
          </v-btn>
        </v-btn-toggle>
      </v-col>
         </v-row>
      
        <line-chart 
          :data="dataCollection"
          :options="options"
          :styles="chartStyles"
          :chart="'er visits per 1000'"
        />
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import LineChart from '../charts/LineChart';

export default {
  components: {
    LineChart,
  },
  props: ["chartInfo", "view"],
  data: () => ({
    dataCollection: null,
    dashboardRange: null,
    chartMonths: [],
    chartValues: [],
    percentDif: 0,
    lineColor:'#90BE6D',
    cancelSource: null,
    loading: false,
    percentDif: 0,
    options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "Months",
              },
              gridLines: {
                color: "rgba(61, 97, 133, 0.25)",
                display: true,
                drawBorder: false,
                drawTicks: false
              },
              ticks: {
                  padding: 10
              }
            },
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Number of ER Visits Per 1000",
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
    },
  }),
  mounted() {
    this.getData();
  },
  methods: {
    // Get  all patients
    async getData() {
      this.chartMonths = [];
      this.chartValues = [];

      this.chartInfo.forEach(info => {
         const value = ((info['er visits'] / info.membership) * 1000).toFixed(2);
        this.chartMonths.push(info.month);
        this.chartValues.push(value);
      });

      this.getPercentDif();
    },
    chartData() {
      this.dataCollection = {
        labels: this.chartMonths,
        datasets: [
          {
           label: "ER Visits Per 1000",
            borderColor: this.lineColor,
            pointBackgroundColor: this.lineColor,
            borderWidth: 3,
            data: this.chartValues,
          },
        ],
      };
    },
    async getPercentDif() {
      // check for undefined values
      const firstVal = this.chartValues[0] ? this.chartValues[0] : 0;
      const lastVal = this.chartValues[this.chartValues.length - 1] ? this.chartValues[this.chartValues.length - 1] : 0;

      const decreaseValue = firstVal - lastVal;
      this.percentDif = firstVal !== 0
        ? Math.ceil((decreaseValue / firstVal) * 100)
        : Math.ceil(decreaseValue * 100);

      this.loading = false;
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
  },
  computed: {
    chartStyles() {
      if(this.view === 'dashboard') {
        return {
          height: '30vh',
        };
      } else {
        return {
          height: '25vh'
        }
      }
    }
  },
  watch: {
    async chartValues() {
      this.chartData();
    },
    async chartInfo() {
      this.getData();
    },
     async dashboardRange() {
      this.$emit("dashboardRange", this.dashboardRange);
    }
  },
};
</script>

<style></style>
